/**
 * Version configuration enum
 *
 * Defines the active design version for the application.
 * This file represents the contract layer and should be stable.
 *
 * Changes here usually require architectural review because they affect system design.
 */
export enum Version {
  V2 = 'v2',
  V3 = 'v3'
}

/**
 * Version configuration contract.
 *
 * Runtime state (active version) lives in `versionConfig.state.ts`, but shares this type
 * to keep a consistent shape (and documentation) across the app.
 */
export type VersionConfigDefinition = {
  active: Version;
  description: string;
};
